import { Widget } from '..'
import { WidgetContainer } from '../../container/WidgetContainerInterface'
import { DragDropAction } from './DragDropAction'
import { DragDropTarget } from './DragDropTarget'

type DragDropCoords = { x: number, y: number }
type DragDropContainerRequestFunc = () => WidgetContainer
type DragDropEventCallbackFunction = (action: DragDropAction, isInitialCall: boolean) => void
type DragDropActionWidgetGetterFunction = (action: DragDropAction) => Widget
type DragDropTargetBoundaries = {
  item: DragDropTarget,
  bottom: number,
  height: number,
  left: number,
  right: number,
  top: number,
  width: number
}
enum DragDropOperationStatus {
  dragging= 'dragging',
  idle = 'idle'
}

export {
  DragDropCoords,
  DragDropEventCallbackFunction,
  DragDropActionWidgetGetterFunction,
  DragDropTargetBoundaries,
  DragDropContainerRequestFunc,
  DragDropOperationStatus
}
